import(/* webpackMode: "eager" */ "/home/r11/choice-graphics/src/app/(pub)/products/[slug]/loading.tsx");
